import { Injectable } from '@angular/core';
import { TopRowFunctionsIdeapadService } from 'src/app/components/pages/page-device-settings/children/subpage-device-settings-input-accessory/top-row-functions-ideapad/top-row-functions-ideapad.service';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { EMachineType } from 'src/app/enums/machine-type.enum';
import { CommonService } from 'src/app/services/common/common.service';
import { InputAccessoriesService } from 'src/app/services/input-accessories/input-accessories.service';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Injectable({
	providedIn: 'root',
})
export class TopRowFunctionFeature {
	constructor(
		private commonService: CommonService,
		private logger: LoggerService,
		private topRowFunctionsIdeapadService: TopRowFunctionsIdeapadService,
		private keyboardService: InputAccessoriesService
	) {}

	public async getCapability(): Promise<boolean> {
		const machineType = this.commonService.getLocalStorageValue(LocalStorageKey.MachineType);

		switch (machineType) {
			case EMachineType.ThinkPad:
				const getTopRowFnLockCapability = this.keyboardService.getTopRowFnLockCapability();
				this.logger.info('TopRowFnLockCapability ThinkPad', getTopRowFnLockCapability);

				return getTopRowFnLockCapability;
			case EMachineType.IdeaPad:
				const getIdeaPadTopRowFnLockCapability =
					this.topRowFunctionsIdeapadService.getCapability();
				this.logger.info(
					'TopRowFnLockCapability IdeaPad',
					getIdeaPadTopRowFnLockCapability
				);

				return getIdeaPadTopRowFnLockCapability;
			default:
				return Promise.resolve(false);
		}
	}
}
